import { Component, Input, OnInit } from '@angular/core';
import { SiteHaulerContractDocuments } from '@app/core/models/site.model';
import { FileService } from '@app/core/services/file.service';
import { SharepointDocumentsService } from '@app/core/services/azure-functions/sharepoint-documents.service';
import { DocumentDetailsModel } from '@app/core/models/document-details.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-site-hauler-contract-documents',
  templateUrl: './site-hauler-contract-documents.component.html',
  styleUrls: ['./site-hauler-contract-documents.component.scss'],
})
export class SiteHaulerContractDocumentsComponent implements OnInit {
  @Input() siteHaulerContractDocuments: SiteHaulerContractDocuments[];
  activeAgreement: string = '';
  subscriptions: Subscription = new Subscription();
  constructor(
    private fileService: FileService,
    private sharepointDocumentService: SharepointDocumentsService
  ) {}

  ngOnInit(): void {
    //
  }

  showContractDocument(accountId: string) {
    if (this.activeAgreement === accountId) {
      this.activeAgreement = '';
    } else this.activeAgreement = accountId;
  }
  downloadFile(documentId: string) {
    this.subscriptions.add(
      this.sharepointDocumentService
        .downloadSiteAgreementDocument(documentId)
        .subscribe((downloadedDocument: DocumentDetailsModel) =>
          this.fileService.createAndDownloadBlobFile(
            downloadedDocument.content,
            downloadedDocument.documentName
          )
        )
    );
  }
}
